import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Container from '@mui/material/Container';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { roleContext } from '../../context/RoleContext';
import { UserRole } from '../../types/role';
import { useLogout } from '../../hooks/useLogout';

const menuItem = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <DashboardOutlinedIcon />,
  },
  {
    path: '/reservation-manager',
    name: 'Reservation Manager',
    icon: <BookOnlineIcon />,
  },
  {
    path: '/calendar-manager',
    name: 'Schedule Manager',
    icon: <CalendarMonthOutlinedIcon />,
  },
  {
    path: '/services',
    name: 'Profile',
    icon: <AccountCircleOutlinedIcon />,
  },
  {
    path: '/account-settings',
    name: 'Account',
    icon: <Person2OutlinedIcon />,
  },
  {
    path: '/subscription-details',
    name: 'Subscription Manager',
    icon: <LoyaltyOutlinedIcon />,
  },
  {
    path: '/',
    name: 'Logout',
    icon: <LockOpenIcon />,
  },
];

export default function SideNav() {
  const role = useContext(roleContext);
  const doLogout = useLogout();

  const isActiveStyle = {
    backgroundColor: 'rgb(215, 167, 72,20%)',
  };

  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent NavLink's own client-side navigation to '/' from racing
    // with the full-page redirect that logout() performs.
    event.preventDefault();
    doLogout();
  };

  const filteredMenuItems = menuItem.filter(
    (item) =>
      !(role === UserRole.SHOP_BARBER && item.name === 'Subscription Manager')
  );

  return (
    <Container
      className="container sideNav"
      component="div"
      sx={{
        width: '280px',
        height: '100vh',
        boxShadow: 2,
        backgroundColor: 'white',
        padding: '0 !important',
      }}
    >
      <Container
        className="sideBar mt-5"
        component="div"
        sx={{ flex: '1', padding: '0 15px !important' }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            padding: '70px 20px 10px ',
            fontWeight: 'bold',
            fontFamily: 'GFS Didot',
          }}
        >
          Pages
        </Typography>
        {filteredMenuItems.map((item, index) => (
          <NavLink
            className={`navLink  ${item.name === 'Logout' ? 'logout' : ''}`}
            style={({ isActive }) =>
              isActive && item.name !== 'Logout'
                ? { ...isActiveStyle }
                : undefined
            }
            to={item.path}
            key={index}
            id="link"
            onClick={item.name === 'Logout' ? handleLogout : undefined}
          >
            <Box
              className="innerBox"
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: 'black',
                marginLeft: '13px',
                fontFamily: 'GFS Didot',
              }}
            >
              {item.icon}
              <Box
                className="innerBox"
                sx={{
                  marginLeft: '15px',
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'GFS Didot',
                }}
              >
                {item.name}
              </Box>
            </Box>
          </NavLink>
        ))}
      </Container>
    </Container>
  );
}
